class MFRPageDots {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)

    this.init()
  }

  init() {
    this.sliderPaginationSize()
    $(window).on('orientationchange resize', this.sliderPaginationSize.bind(this))
  }

  sliderPaginationSize() {
    setTimeout(() => {
      this.$sliderDots = this.$element.find('.flickity-page-dots').children()

      Array.from(this.$sliderDots).forEach((item) => {
        let slideDotsWidth = 100 / this.$sliderDots.length
        let slideMargins = 6

        item.style.width = `calc( ${slideDotsWidth}% - ${slideMargins}px )`
      })
    }, 2000)
  }
}